/*jshint esversion: 8 */
import Vue from 'vue';
import axios from 'axios';
import { extractErrorDetails } from '@/helpers/util.js';
import { BufferGeometryLoader } from 'three';


const initialState = () => ({
  glbs: {},
  project_elements: {},
  project_steps: {},
  ifc_upload_loaded: 0,
  ifc_upload_total: 0,
  ifc_upload_percentage: 0,

  ui_mode: { value: 'view', text: 'View Mode 2'},
  ui_mode_options: [{value: 'view', text: 'View Mode'}, {value: 'edit', text: 'Edit Mode'}, {value: 'link', text: 'Linking Mode'}, {value: '4d', text: '4D Simulation'}],

  show_taktarea_linked_edges: true,
  show_steps_linked_edges: true,
  show_taktareashapes: true,

  // object id collections
  visible_elements: {
    elements: [], //visible in 3D
  },
  visible_taktareashapes: {
    taktareashapes: [],
  },
  selected_elements: {
    elements: [],
  },
  selected_steps: {
    tworksteps: []
  },
  filter: {
    spatial: {
      active: false,
      objects: {
        elements: []
      }
    },
    process: {
      active: false,
      objects: {
        tworksteps: []
      }
    }
  },

  // do as computed:
  // linked_element_ids: [], //linked elements to step of process object
  // linked_ta_element_ids: [], //linked elements to taktarea of process object
  // linked_step_ids: [], //linked steps of spatial object

  // tree settings
  // trees: 
  // - spatial:
  // 'spatial_tree',
  // 'spatial_collection'
  // 'step_elements',
  // 'taktarea_elements',

  // -process:
  // 'process_tree',
  // 'process_collection', -> process_collection_steps || process_collection_taktareas
  // 'element_steps',
  // 'element_taktareas',

  tree_settings_wrapper: {},
  tree_settings_sorting: {},
  tree_settings_grouping: {},
  // constants
  tree_objects_spatial: [
    'sites',
    'spatialzones',
    'buildings',
    'buildingstoreys',
    'spacegroups',
    'elementassemblies',
    'elements'
  ],
  tree_objects_process: [
    'trains',
    'taktareas',
    'twaggons',
    'tworkpackages',
    // 'tlogisticsteps',
    // 'tdesignsteps',
    'tworksteps',
    // 'tqualitysteps',
    // 'tdefectsteps',
    // 'thandoversteps',
    // 'tmachinesteps',
  ],
  default_tree_settings_wrapper: {
        element_steps: {
          trains: false,
          taktareas: false,
          twaggons: false,
          tworkpackages: false,
        },
        element_taktareas: {
          trains: false
        },
        process_collection: {
          trains: false,
          taktareas: false,
          twaggons: false,
          tworkpackages: false,
        }, 
        step_elements: {
          sites: false,
          spatialzones: false,
          buildings: false,
          buildingstoreys: false,
          spacegroups: false,
          elementassemblies: false,
        },
        taktarea_elements: {
          sites: false,
          spatialzones: false,
          buildings: false,
          buildingstoreys: false,
          spacegroups: false,
          elementassemblies: false,
        },
        spatial_collection: {
          sites: false,
          spatialzones: false,
          buildings: false,
          buildingstoreys: false,
          spacegroups: false,
          elementassemblies: false,
        },
  }
});

// State object
const state = initialState();
// Getter functions
const getters = {
  // ------- new projectstructure main functions start --------
  getTreeChildObjects: (state, getters, rootState) => (payload) => { //always complete tree, filter then in tree component with isSet1inSet2
    // let start;
    // if (!payload.recursive) {
    //   // console.log('tree child start');
    //   start = new Date().getTime();
    // }
    //payload: parent, tree_type, tree_name
    let tree_settings_wrapper = state.tree_settings_wrapper[payload.tree_name];
    let tree_settings_grouping = state.tree_settings_grouping[payload.tree_name];
    let tree_settings_sorting = state.tree_settings_sorting[payload.tree_name];
    let child_wrappers = [];
    let child_object_wrappers = {};
    let child_objects = []; // difference because of sorting
    if (payload.child_wrappers) {
      child_wrappers = payload.child_wrappers;
      child_object_wrappers = payload.child_object_wrappers;
      child_objects = payload.child_objects;
    }
    // traverse wrappers
    state[`tree_objects_${payload.tree_type}`].forEach(type => {
      let child_arr = payload.parent[type];
      if (child_arr) { // if parent has child type
        if (type === 'elements' || type.includes('steps')) { // handle elements and steps
          if (payload.parent.type === 'object_wrapper' || !tree_settings_wrapper.object_wrapper) {
            for (let i = 0; i < child_arr.length; i++) {
              let id = child_arr[i];
              child_objects[child_objects.length] = rootState.Ultra[type][id];
            }
          } else { // handle step and element wrapper
            for (let i = 0; i < child_arr.length; i++) {
              let id = child_arr[i];
              let child_object = rootState.Ultra[type][id];
              let wrapper_name = child_object[tree_settings_grouping.group_by];
              if (!child_object_wrappers[wrapper_name]) {
                child_object_wrappers[wrapper_name] = {
                  id: 'object_wrapper#' + payload.parent.type + payload.parent.id + wrapper_name,
                  type: 'object_wrapper',
                  content_type: type,
                  name: `${wrapper_name}s`,
                  [type]: [],
                }
              }
              child_object_wrappers[wrapper_name][type][child_object_wrappers[wrapper_name][type].length] = id
            }
          }
        } else if (tree_settings_wrapper[type]) { //handle visible wrappers
          for (let i = 0; i < child_arr.length; i++) {
            let id = child_arr[i];
            child_wrappers[child_wrappers.length] = rootState.Ultra[type][id];
          }
        } else { // handle invisible wrappers
          for (let i = 0; i < child_arr.length; i++) {
            let id = child_arr[i];
            let child_wrapper = rootState.Ultra[type][id];
            getters.getTreeChildObjects({
              parent: child_wrapper,
              tree_type: payload.tree_type,
              tree_name: payload.tree_name,
              child_wrappers: child_wrappers,
              child_object_wrappers: child_object_wrappers,
              child_objects: child_objects,
              recursive: true,
            });
          }
        }

      }
    })

    // handling elements at the end
    if (!payload.recursive) {
      let all_children = [];
      // wrappers
      for (let i = 0; i < child_wrappers.length; i++) {
        let wrapper = child_wrappers[i];
        all_children[all_children.length] = wrapper;
      }
      // object_wrappers
      let child_object_wrappers_arr = Object.values(child_object_wrappers);
      for (let i = 0; i < child_object_wrappers_arr.length; i++) {
        let object_wrapper = child_object_wrappers_arr[i];
        all_children[all_children.length] = object_wrapper;
      }
      // sorted elements
      let sort_prop = tree_settings_sorting.sort_by;
      let sort_direction = tree_settings_sorting.sort_direction;
      if (sort_direction === 'up') {
        child_objects.sort((a, b) => {
          return a[sort_prop] - b[sort_prop];
        });
      } else {
        child_objects.sort((a, b) => {
          return b[sort_prop] - a[sort_prop];
        });
      }
      for (let i = 0; i < child_objects.length; i++) {
        let child_object = child_objects[i];
        all_children[all_children.length] = child_object;
      }
      // let end = new Date().getTime();
      // console.log('tree child: ' + (end - start));
      return all_children;
    }
    // else {
    //   return {
    //     child_wrappers: child_wrappers,
    //     child_object_wrappers: child_object_wrappers,
    //     child_objects: child_objects,
    //   }
    // }
  },
  getAllChildObjectIds: (state, getters, rootState) => (payload) => {
    // let start;
    // if (!payload.recursive) {
    //   // console.log('child object start');
    //   start = new Date().getTime();
    // }
    // console.log(payload);
    // payload: parent, tree_type ('spatial' / 'process'), targets (['elements', 'steps', 'taktareas', 'ta_elements']), state filter instead of filtered_ids
    // handle object wrapper

    // define filter funktion
    let isInFilter;
    if (!payload.recursive) {
      isInFilter = function(filter, filter_set, id) {
        // let filter_object_ids = filter.objects[target];
        // let filter_object_ids = new Set(filter.objects[target]);
        if (!filter.active || !filter_set || (filter.active && (filter_set.has(id) || filter_set.has(parseInt(id))))) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      isInFilter = payload.isInFilter;
    }

    let ids_by_target = {};
    if (payload.ids_by_target) {
      ids_by_target = payload.ids_by_target;
    }

    for (let j = 0; j < payload.targets.length; j++) { //iterate over all targets and collect them up
      // definde target
      let target = payload.targets[j];

      if (!ids_by_target[target]) { //initialize target object array
        ids_by_target[target] = [];
      }
      let arr = ids_by_target[target];
      // define filter object
      let filter;
      if (['ta_elements', 'elements'].includes(target)) {
        filter = state.filter.spatial;
      } else {
        filter = state.filter.process;
      }
      let filter_set = new Set(filter.objects[target]);

      // edge case if not recursive entry payload parent is smalles object
      // ta_elements
      if (!payload.recursive && target === 'ta_elements' && payload.parent_type === 'elements') { //filter
        filter_set = new Set(filter.objects.elements);
        if (isInFilter(filter, filter_set, payload.parent.id)) {
          arr[arr.length] = payload.parent.id;
        }
      }
      else if (!payload.recursive && payload.parent.type === target && isInFilter(filter, filter_set, payload.parent.id)) { //filter
        arr[arr.length] = payload.parent.id;
      }
      // taktarea elements
      else if (target === 'ta_elements' && (payload.parent.type === 'taktareas' || payload.tree_type === 'spatial') && payload.parent.elements) {
        let arr2 = payload.parent.elements;
        filter_set = new Set(filter.objects.elements);
        for (let i = 0; i < arr2.length; i++) {
          let id = parseInt(arr2[i]);
          if (isInFilter(filter, filter_set, id)) { //filter
            arr[arr.length] = id;
          }
        }
      } else if (target !== 'ta_elements' && payload.parent[target] && (payload.parent.type !== 'taktareas' || target !== 'elements')) {
        let arr2 = payload.parent[target];
        for (let i = 0; i < arr2.length; i++) {
          let id = parseInt(arr2[i]);
          if (isInFilter(filter, filter_set, id)) { //filter
            arr[arr.length] = id;
          }
        }
      }
    }

    let tree_objects = state[`tree_objects_${payload.tree_type}`];

    tree_objects.forEach(tree_object => {
      if (payload.parent[tree_object]) {
        let next = false;
        // check edge cases
        if (payload.tree_type === 'process' && payload.targets.length === 1 && payload.targets[0] === 'ta_elements' && !['trains', 'taktareas'].includes(tree_object)) { //search for ta_elements
          next = false
        } else if (tree_object !== 'elements' && !tree_object.includes('steps')) { //wrapper
          next = true;
        } else if (tree_object === 'elements') { //search for elements steps
          payload.targets.forEach(target => {
            if (target.includes('steps') || target === 'taktareas') {
              next = true;
            }
          })
        } else if (tree_object.includes('steps') && payload.targets.includes('elements')) { //search for steps elements
          next = true;
        }
        if (next) {
          let ids = payload.parent[tree_object];
          for (let i = 0; i < ids.length; i++) { 
            let id = ids[i];
            let next_parent = rootState.Ultra[tree_object][id];
            getters.getAllChildObjectIds({
              parent: next_parent,
              tree_type: payload.tree_type,
              targets: payload.targets,
              ids_by_target: ids_by_target,
              recursive: true,
              isInFilter: isInFilter,
            })
          }
        }
      }
    });

    if (!payload.recursive) {
      // // console.log('child object end');
      // let end = new Date().getTime();
      // console.log('child ids: ' + (end - start));
      return ids_by_target;
    }
  },
  isSet1inSet2: (state, getters) => payload => {
    // console.log('------ set in set start ------');
    // let start = new Date().getTime();

    // console.log(payload);
    // compare same entity types: e.g. are all elements of building(-object) in spatial_selection(-collection)
    // payload: tree_type, object || ids_by_target, collection_name('visible_elements') || collection_object({tworksteps: [1,2,3]}), (targets not needed anymore -> keys in collection)
    // early out !!!
    // payload:
    // set1, set2: {type: 'ids_by_target' || object || collection_name, value: {}, tree_type: ''spatial' || 'process' (when type is object)} -> get ids_by_target (smallest objects)
    // targets:['elements', 'ta_elements', 'tworksteps'] -> target keys to compare
    
    // set1 is empty case: complete or none
    // set1_empty_case: 'complete' || 'none' || null --> complete

    // initiate resp
    let resp = {
      result: 'complete',
      color: 'white',
      result_by_target: {},
    };

    // define filter funktion
    let filter_ids_by_target = function(state, ids_by_target) {
      // console.log(' ------filter start---------');
      // let start = new Date().getTime();
      let filtered_ids_by_target = {};
      // let keys = Object.keys(ids_by_target);
      for (let j = 0; j < Object.keys(ids_by_target).length; j++) {
        let target = Object.keys(ids_by_target)[j];

      // Object.keys(ids_by_target).forEach(target => {
        filtered_ids_by_target[target] = [];
        let filter;
        if (['ta_elements', 'elements'].includes(target)) {
          filter = state.filter.spatial;
        } else {
          filter = state.filter.process;
        }
        // console.log('new set');
        // console.log('end new set');
        // console.log(ids_by_target[target].length);
        let filtered_target_ids = filtered_ids_by_target[target];
        let target_ids = ids_by_target[target];
        // let filter_object_ids = filter.objects[target];
        let filter_set = new Set(filter.objects[target]);
        for (let i = 0; i < target_ids.length; i++) {
          let id = target_ids[i];
          if (!filter.active || !filter_set || (filter.active && (filter_set.has(id) || filter_set.has(parseInt(id))))) {
            filtered_target_ids[filtered_target_ids.length] = id;
          }
        }
      // })
      }
      // let end = new Date().getTime();
      // console.log('duration: ' + (end - start));
      // console.log('----------filter end---------');
      return filtered_ids_by_target;
    }
    // hanlde sets
    let get_ids_by_target = function(set, targets, state, getters) {
      let ids_by_target = {};
      if (set.type === 'ids_by_target') {
        // ids_by_target = set.value;
        ids_by_target = filter_ids_by_target(state, set.value);
      } else if (set.type === 'collection_name') {
        ids_by_target = filter_ids_by_target(state, state[set.value]);
      } else if (set.type === 'object') {

        let object = set.value;
        let tree_type = set.tree_type;

        let handle_wrapper = true;
        targets.forEach(target => {
          if (target === object.type || (target === 'ta_elements' && object.type === 'elements')) { //smalles object type elements || steps
            // ids_by_target[target] = [`${payload.object.id}`];
            // ids_by_target[target] = [object.id];
            ids_by_target[target] = filter_ids_by_target(state, {[target]: [object.id]})[target];
            handle_wrapper = false;
          }
        });
        if (handle_wrapper) {
          ids_by_target = getters.getAllChildObjectIds({ tree_type: tree_type, parent: object, targets: targets });
        }
        // old logic
        // // handle wrapper
        // if (object.type !== 'elements' && !object.type.includes('steps')) {
        //   ids_by_target = getters.getAllChildObjectIds({ tree_type: tree_type, parent: object, targets: targets });
        // } 
        // // handle smallest object
        // else {
        //   targets.forEach(target => {
        //     if (target === object.type || (target === 'ta_elements' && object.type === 'elements')) { //smalles object type elements || steps
        //       // ids_by_target[target] = [`${payload.object.id}`];
        //       ids_by_target[target] = [object.id];
        //     }
        //   });
        // }
      }
      return ids_by_target;
    }
    let ids_by_target1 = get_ids_by_target(payload.set1, payload.targets, state, getters); //set 1
    //early out if no set2 -> complete spatial or process tree
    let ids_by_target2;
    if (!payload.set2.value) {
      ids_by_target2 = ids_by_target1;
      // payload.targets.forEach(target => {
      //   resp.result_by_target[target] = { result: 'complete', color: 'white', contained_ids: ids_by_target1[target] };
      // })
      // return resp;
    } else {
      ids_by_target2 = get_ids_by_target(payload.set2, payload.targets, state, getters); //set 2
    }

    // let collection;
    // if (payload.collection_object) {
    //   collection = payload.collection_object;
    // } else if (payload.collection_name) {
    //   collection = state[payload.collection_name];
    // } else {
    //   collection = false;
    // }
    // let targets;
    // if (collection) {
    //   targets = Object.keys(collection);
    // } else if (payload.tree_type === 'spatial') {
    //   targets = ['elements'];
    // } else {
    //   targets = ['tworksteps'];
    // }

    // let ids_by_target = {};
    // // if ids are given
    // if (payload.ids_by_target) {
    //   ids_by_target = payload.ids_by_target;
    // }
    // // else
    // // collect object ids by target type
    // // if is wrapper 
    // // handle object wrapper in getAllChildObjectIds

    // else if (payload.object.type !== 'elements' && !payload.object.type.includes('steps')) {
    //   // ids_by_target = getters.getAllChildElements({ parent_type: payload.object.type, parent_id: payload.object.id });
    //   ids_by_target = getters.getAllChildObjectIds({ tree_type: payload.tree_type, parent: payload.object, targets: targets });
    // } else {
    //   targets.forEach(target => {
    //     if (target === payload.object.type || (target === 'ta_elements' && payload.object.type === 'elements')) { //smalles object type elements || steps
    //       // ids_by_target[target] = [`${payload.object.id}`];
    //       ids_by_target[target] = [payload.object.id];
    //     }
    //   });
    // }

    // helper functions
    function isSuperset(set, subset) {
      for (var elem of subset) {
        if (!set.has(`${elem}`) && !set.has(parseInt(elem))) {// handle also integer ids
          return false;
        }
      }
      return true;
    }
    function intersection(setA, setB) {
      // var _intersection = new Set();
      let intersection = [];
      for (var elem of setB) {
        if (setA.has(`${elem}`)) {
          // _intersection.add(`${elem}`);
          // intersection[intersection.length] = `${elem}`;
          intersection[intersection.length] = parseInt(elem); // always return integer
        } else if (setA.has(parseInt(elem))) { // handle integer ids
          // _intersection.add(${parseInt(elem)});
          intersection[intersection.length] = parseInt(elem);
        }
      }
      // return _intersection;
      return intersection;
    }

    // iterate over multiple targets
    let none_count = 0;
    payload.targets.forEach(target => {
      // is subset in set?
      // handle ta_elements
      let get_target_ids = function(ids_by_target, target) {
        let target_ids;
        if (target === 'elements' && !ids_by_target.elements) {
          target_ids = ids_by_target.ta_elements;
        } else if (target === 'ta_elements' && !ids_by_target.ta_elements) {
          target_ids = ids_by_target.elements;
        } else {
          target_ids = ids_by_target[target];
        }
        return target_ids;
      };
      let subset_ids = get_target_ids(ids_by_target1, target); //set 1
      let set_ids = get_target_ids(ids_by_target2, target); //set 2
      if (subset_ids && subset_ids.length !== 0 && set_ids && set_ids.length !== 0) {
        // create sets
        let subset = new Set(subset_ids); //set 1
        let set = new Set(set_ids); //set2
        if (isSuperset(set, subset)) {
          set = null;
          subset = null;
          resp.result_by_target[target] = { result: 'complete', color: 'white', contained_ids: subset_ids };
        } else { //if not superset
          let element_intersection = intersection(set, subset);
          if (element_intersection.length === 0) {
            resp.result_by_target[target] = { result: 'none', color: 'grey darken-3', contained_ids: element_intersection };
            resp.result = 'part';
            resp.color = 'grey darken-1';
            none_count++;
            set = null;
            subset = null;
            element_intersection = null;
          } else {
            resp.result_by_target[target] = { result: 'part', color: 'grey darken-1', contained_ids: element_intersection };
            resp.result = 'part';
            resp.color = 'grey darken-1';
            set = null;
            subset = null;
            element_intersection = null;
          }
        }
      } else if (subset_ids.length === 0 || set_ids.length === 0) {

        if (subset_ids.length === 0 && payload.set1_empty_case === 'complete') {
          // set1_empty_case: 'complete' || 'none' || null --> complete
          resp.result_by_target[target] = { result: 'complete', color: 'white', contained_ids: subset_ids };
        } else {
          // when no objects in subset_ids or set ids
          resp.result_by_target[target] = { result: 'none', color: 'grey darken-3', contained_ids: subset_ids };
          resp.result = 'part';
          resp.color = 'grey darken-1';
          none_count++;
        }
      }
      else {
        // when no objects in subset_ids
        resp.result_by_target[target] = { result: 'complete', color: 'white', contained_ids: subset_ids };
      }

    });
    if (none_count === payload.targets.length) {
      resp.result = 'none';
      resp.color = 'grey darken-3';
    }
    // let end = new Date().getTime();
    // console.log('SetInSet: ' + (end - start));
    // console.log('----- set in set end -----');
    return resp;

  },
  isSet1LinkedToSet2: (state, getters, rootState) => payload => {
    // console.log('set link set start');

    // set 1 is subset (ids of linked entities: building -> all elements -> is every linked?) 
    // set 2 is set (ids of linking parents) -> get linked entity ids and check if subset is contained -> train -> all linked elements
    // payload: 
    // set1, set2: {type: 'ids_by_target' || object || collection_name, value: {}}
    // targets:['elements', 'ta_elements', 'tworksteps']

    let objects = [];
    let set2 = payload.set2;

    let getObjects = function(arr) {
      let objects = [];
      Object.keys(arr).forEach(target => {
        let ids = arr[target];
        let entities = rootState.Ultra[target];
        for (let i = 0; i < ids.length; i++) {
          let id = ids[i];
          objects[objects.length] = entities[id];
        }
      })
      return objects;
    }

    if (set2.type === 'ids_by_target') {
      let arr = set2.value;
      objects = getObjects(arr);
    } else if (set2.type === 'collection_name') {
      let arr = state[set2.value];
      objects = getObjects(arr);
    } else if (set2.type === 'object') {
      objects[0] = set2.value;
    }
    // initialize response
    let resp = {
      result: 'complete',
      color: 'white',
      objects: objects,
      object_results: [],
      // all_min_1: true
    };
    let none_count = 0;
    // check each object for link to set 1
    for (let j = 0; j < objects.length; j++) {
      let object = objects[j];
      let result = getters.isSet1inSet2({
        set1: payload.set1,
        set2: {type: 'object', value: object, tree_type: payload.targets.includes('elements') || payload.targets.includes('ta_elements')?'process':'spatial'}, //better solution for tree_type?
        targets: payload.targets,
      })
      resp.object_results[resp.object_results.length] = result;
      if (result.result === 'none') {
        resp.result = 'part'
        resp.color = 'grey darken-1';
        none_count++
      } else if (result.result === 'part') {
        resp.result = 'part'
        resp.color = 'grey darken-1';
      }
    }
    if (none_count === objects.length) {
      resp.result = 'none'
      resp.color = 'grey darken-3';
    }

    // resp.all_min_1 = none_count === 0;

    // console.log('set link set end');
    return resp;
  },
  getObjectUrl: (state, getters, rootState) => (object, recursive_resp) => {
    let resp;
    if (recursive_resp) { // if is recursive
      resp = recursive_resp
    } else {
      resp = {
        url: [],
        path: [],
      };
    }
    let ultra_object = rootState.Ultra[object.type][object.id]
    resp.url.unshift({ [ultra_object.type]: ultra_object.id }); //add to url
    resp.path.unshift({ type: ultra_object.type, id: ultra_object.id, name: ultra_object.name }); //add to path
    if (ultra_object.type !== 'projects') {
      let new_object = ultra_object.parent;
      getters.getObjectUrl(new_object, resp); // recursion with url object
    }
    if (!recursive_resp) {
      return resp; //return url on recursive entry point
    }
  },
  getCollectionParents: (state, getters, rootState) => (payload) => {
    // payload: collection_object({tworksteps: [1,2,3,4,5]}) || collection_name('selected_steps') ; target_types: ['taktareas', ...]
    let collection;
    if (payload.collection_object) {
      collection = payload.collection_object;
    } else if (payload.collection_name) {
      collection = state[payload.collection_name];
    }
    // recursive function
    let collectParents = function(parents, target_types, object, rootState) {
      if (object.parent && object.parent.type) { // if object has a parent 
        if (!target_types || (target_types.includes(object.parent.type))) { // add if no target_types defined or is target type
          if (!parents[object.parent.type]) { // add parent set if not yet added
            parents[object.parent.type] = new Set();
          }
          if (!parents[object.parent.type].has(object.parent.id)) {
            parents[object.parent.type].add(object.parent.id); // add parent id if not yet added
          }
        }
        let next_object = rootState.Ultra[object.parent.type][object.parent.id];
        collectParents(parents, target_types, next_object, rootState)
      }
    };

    let parents = {};
    Object.keys(collection).forEach(type => { // for each entity in collection
          for (let i = 0; i < collection[type].length; i++) { // iterate over all entity ids
            let id = collection[type][i];
            let object = rootState.Ultra[type][id];
            collectParents(parents, payload.target_types, object, rootState)
          }
        });
    let resp = {};
    Object.keys(parents).forEach(type => {
      resp[type] = Array.from(parents[type]);
    });
    // if collection is empty 
    if (Object.keys(resp).length === 0) {
      payload.target_types.forEach(type => {
        resp[type] = [];
      })
    }
    return resp;
  },
  // ------- new projectstructure main functions end --------

  getBackgroundColor: () => (depth) => {
    switch (depth) {
      case 1:
        return '#212121';
      case 2:
        return '#424242';
      case 3:
        return '#616161';
      case 4:
        return '#757575';
      case 5:
        return '#BDBDBD';
      default:
        return '#E0E0E0';
    }
  },
  getForegroundColor:() => (depth) => {
    if(depth >= 5){
      return '#424242';
    } else {
      return '#FAFAFA';
    }
  },
  getIfcElementTypes: (state, getters, rootState) => {
    return rootState.Ultra.ifc_types.filter(type => ![
      'IFCPROJECT',
      'IFCSITE',
      'IFCBUILDING',
      'IFCBUILDINGSTOREY',
      'IFCSPACE',
    ].includes(type.value));
  },
  getProjectWrapper: (state, getters, rootState) => (payload) => {

    if (payload.wrapper_to_check.length == 0) {
      return payload.wrapper;
    }

    if (!payload.wrapper) {
      payload.wrapper = []
    }

    // get first wrapper in wrappers
    let current_wrapper = payload.wrapper_to_check.shift();

    if (rootState.Ultra[current_wrapper.type][current_wrapper.id]) {
      let current_entity = rootState.Ultra[current_wrapper.type][current_wrapper.id];

      // add wrapper to result (payload.wrapper)
      // unless it is the project entity...
      if (current_wrapper.type !== 'projects') {
        current_entity['text'] = current_entity.name;
        current_entity['value'] = current_entity.id;
        payload.wrapper.push(current_entity);
      }

      // add child wrappers to the wrappers to check...
      switch (current_wrapper.type) {
        case 'projects':
          current_entity.sites.forEach(id => {
            payload.wrapper_to_check.push({ type: 'sites', id: id });
          });
          break;
        case 'sites':
          current_entity.sites.forEach(id => {
            payload.wrapper_to_check.push({ type: 'sites', id: id });
          });
          current_entity.spatialzones.forEach(id => {
            payload.wrapper_to_check.push({ type: 'spatialzones', id: id });
          });
          current_entity.buildings.forEach(id => {
            payload.wrapper_to_check.push({ type: 'buildings', id: id });
          });
          current_entity.elementassemblies.forEach(id => {
            payload.wrapper_to_check.push({ type: 'elementassemblies', id: id });
          });
          break;
        case 'spatialzones':
          current_entity.spatialzones.forEach(id => {
            payload.wrapper_to_check.push({ type: 'spatialzones', id: id });
          });
          current_entity.elementassemblies.forEach(id => {
            payload.wrapper_to_check.push({ type: 'elementassemblies', id: id });
          });
          break;
        case 'buildings':
          current_entity.buildings.forEach(id => {
            payload.wrapper_to_check.push({ type: 'buildings', id: id });
          });
          current_entity.buildingstoreys.forEach(id => {
            payload.wrapper_to_check.push({ type: 'buildingstoreys', id: id });
          });
          current_entity.spacegroups.forEach(id => {
            payload.wrapper_to_check.push({ type: 'spacegroups', id: id });
          });
          current_entity.elementassemblies.forEach(id => {
            payload.wrapper_to_check.push({ type: 'elementassemblies', id: id });
          });
          break;
        case 'buildingstoreys':
          current_entity.buildingstoreys.forEach(id => {
            payload.wrapper_to_check.push({ type: 'buildingstoreys', id: id });
          });
          current_entity.spacegroups.forEach(id => {
            payload.wrapper_to_check.push({ type: 'spacegroups', id: id });
          });
          current_entity.elementassemblies.forEach(id => {
            payload.wrapper_to_check.push({ type: 'elementassemblies', id: id });
          });
          break;
        case 'spacegroups':
          current_entity.spacegroups.forEach(id => {
            payload.wrapper_to_check.push({ type: 'spacegroups', id: id });
          });
          current_entity.elementassemblies.forEach(id => {
            payload.wrapper_to_check.push({ type: 'elementassemblies', id: id });
          });
          break;
        case 'elementassemblies':
          current_entity.elementassemblies.forEach(id => {
            payload.wrapper_to_check.push({ type: 'elementassemblies', id: id });
          });
          break;
      }
      return getters.getProjectWrapper(payload);
    }
    return payload.wrapper;
  },
  getParentsFloorPlans: (state, getters, rootState) => (payload) => {
    let element = rootState.Ultra[payload.type][payload.id];
    let floor_plans = [];
    let floor_plan = {};
    while (element.type !== 'sites') {
      if (element.plans.length !== 0) {
        floor_plan = {
          element: element,
          plan: rootState.Ultra.plans[rootState.Ultra[element.type][element.id].plans[0]]
        };
        floor_plans.push(JSON.parse(JSON.stringify(floor_plan)));
      }
      element = rootState.Ultra[element.parent.type][element.parent.id];
    }
    if (element.type === 'sites' && element.plans.length !== 0) {
      floor_plan = {
        element: element,
        plan: rootState.Ultra.plans[rootState.Ultra[element.type][element.id].plans[0]]
      };
      floor_plans.push(JSON.parse(JSON.stringify(floor_plan)));
    }
    floor_plans.reverse();
    return floor_plans;
  },
  getTaktareasForSpatialStructure: (state, getters, rootState) => (payload) => {
    let parent = rootState.Ultra[payload.parent_type][payload.parent_id];
    let container = {
      id: parent.id,
      type: parent.type,
      closed: parent.type === 'projects' ? false : parent.closed,
      taktareas: [],
      elements: [],
      containers: [],
    };


    if (parent.elements) {
      parent.elements.forEach(el => {
        let taktareas = Object.values(rootState.Ultra.taktareas).filter(taktarea => taktarea.elements.includes(el));
        container.elements.push({ id: el, taktareas: taktareas });
        taktareas.forEach(taktarea => {
          if (container.taktareas.findIndex(ta => ta.id === taktarea.id) === -1) {
            container.taktareas.push(taktarea);
          }
        });

      });
    }

    ['sites', 'spatialzones', 'buildings', 'buildingstoreys', 'spacegroups', 'elementassemblies'].forEach(el => {
      if (parent[el]) {
        parent[el].forEach(id => {
          let parent2 = rootState.Ultra[el][id];
          container.containers.push(getters.getTaktareasForSpatialStructure({ parent_type: parent2.type, parent_id: parent2.id }));
        });
      }
    });
    return container;
  },
  getElementsTotalValue: (state, getters, rootState) => (payload) => {
    let sum = 0;
    payload.elements.forEach(id => {
      sum += rootState.Ultra.elements[id][payload.mass_relation];
    });
    return sum;
  },
  calcAllWorkStepsTotal: (state, getters, rootState, rootGetters) => ({ workpackage, prefix }) => {
    let total = {
      icon: 'mdi-speedometer',
      value: 0,
      unit: 'mh',
    };
    let steps = rootGetters['Ultra/getUObjects']({ type: `${prefix}worksteps`, ids: workpackage[`${prefix}worksteps`] });
    steps.forEach(step => {
      if (step.mass_relation !== 'absolute') {
        let step_total = getters.calcStepTotal(step, 'Work', false, prefix);
        if (step_total) {
          total.value += step_total.value;
        }
      } else {
        total.value += step.performance_value;
      }
    });
    total.value = Math.round(total.value * 100) / 100;
    return total;
  },
  calcStepTotal: (state, getters, rootState) => (step, step_type, element_ids, prefix) => {
    if (step.mass_relation !== 'none' && step_type === 'Work') {
      let elements;
      if (element_ids) {
        elements = element_ids;
      } else {
        elements = step.elements;
      }
      let value;
      let total_mass;
      // if (elements.length === 0 && step.mass_relation !== 'absolute') {
      if (!step.loaded_from_backend) {
        value = step.calculated_planned_time_effort;
        total_mass = 0;
      } else {
        value = step.performance_value;
        total_mass = 0;
        if (step.mass_relation !== 'absolute') {
          total_mass = getters.getElementsTotals(elements)[step.mass_relation];
          value = total_mass * step.performance_value;
        }
        value = Math.round(value * 100) / 100;
        total_mass = Math.round(total_mass * 100) / 100;
      }
      return {
        icon: 'speedometer',
        value: value,
        unit: 'mh',
        total_mass: total_mass,
      };
    } else if (step.mass_relation !== 'none' && step_type === 'Material' && step[`${prefix}worksteps`].length !== 0) {
      let elements;
      if (element_ids) {
        elements = element_ids;
      } else {
        elements = rootState.Ultra[`${prefix}worksteps`][step[`${prefix}worksteps`][0]].elements;
      }
      let value = step.conversion_factor;
      let total_mass = getters.getElementsTotals(elements)[step.mass_relation];
      if (step.mass_relation !== 'absolute') {
        value = total_mass * step.conversion_factor;
      }
      value = Math.round(value * 100) / 100;
      total_mass = Math.round(total_mass * 100) / 100;
      let unit;
      if (step.conversion_unit !== 'none') {
        unit = rootState.Ultra.conversion_units.find(unit => unit.value === step.conversion_unit).unit;
      } else {
        unit = rootState.Ultra.expense_units.find(unit => unit.value === step.mass_relation).unit;
      }
      return {
        icon: 'wall-brick',
        value: value,
        unit: unit,
        total_mass: total_mass,
      };
    } else {
      return false;
    }
  },
  getIFCItems: (state, getters, rootState, rootGetters) => (project_id) => {
    let items = JSON.parse(JSON.stringify(rootState.Ultra.projects[project_id].textures));
    Object.keys(items).forEach(texture_id => {
      let elements = rootGetters['Ultra/getUObjectsFiltered']({
        type: 'elements',
        filter: {
          texture_id: texture_id,
          visible: true
        }
      });
      elements.forEach(element => {
        const loader = new BufferGeometryLoader;
        let buffer_geometry = loader.parse(element.geometry);
        items[texture_id].geometries[element.express_id] = buffer_geometry;
      });
    });
    return items;
  },
  getElementsTotals: (state, getters, rootState) => (ids) => {
    let totals = {
      lateral_surface: 0,
      perimeter: 0,
      floor_area: 0,
      ceiling_area: 0,
      volume: 0,
      height: 0,
      length: 0,
      width: 0,
      weight: 0,
      side_area: 0,
      surface: 0,
      count: 0,
    };
    ids.forEach((id) => {
      if (rootState.Ultra.elements[id]) {
        let el = rootState.Ultra.elements[id];
        totals.lateral_surface += el.lateral_surface;
        totals.perimeter += el.perimeter;
        totals.floor_area += el.floor_area;
        totals.ceiling_area += el.ceiling_area;
        totals.volume += el.volume;
        totals.height += el.height;
        totals.length += el.length;
        totals.width += el.width;
        totals.weight += el.weight;
        totals.side_area += el.side_area;
        totals.surface += el.surface;
        totals.count += 1;
      }
    });
    return totals;
  },
  getImportStrategies: (state, getters, rootState, rootGetters) => {
    let strategies = [{ value: 'default', text: 'Default' }];
    let current_user = rootGetters['Auth/getUser'];
    let business = rootState.Ultra.businesses[current_user.business.id];
    if (business) {
      let business_strategies = rootGetters['Ultra/getUObjects']({ type: 'bifcimportstrategies', ids: business.bifcimportstrategies });
      business_strategies.forEach(strategy => {
        strategies.push({ value: strategy.id, text: strategy.name });
      });
    }
    return strategies;
  },
  getQuantitiesByElementIds: (state, getters, rootState) => (element_ids) => {
    let elements = element_ids.map(id => rootState.Ultra.elements[id]);

    // quantities object having ifc_type as keys and quantities as values including count
    let quantities = {};
    elements.forEach(element => {
      if (!quantities[element.ifc_type]) {
        quantities[element.ifc_type] = {
          count: 0,
          lateral_surface: 0,
          perimeter: 0,
          floor_area: 0,
          volume: 0,
          height: 0,
          length: 0,
          width: 0,
          weight: 0,
          side_area: 0,
          surface: 0,
        };
      }
      quantities[element.ifc_type].count += 1;
      quantities[element.ifc_type].lateral_surface += element.lateral_surface;
      quantities[element.ifc_type].perimeter += element.perimeter;
      quantities[element.ifc_type].floor_area += element.floor_area;
      quantities[element.ifc_type].volume += element.volume;
      quantities[element.ifc_type].height += element.height;
      quantities[element.ifc_type].length += element.length;
      quantities[element.ifc_type].width += element.width;
      quantities[element.ifc_type].weight += element.weight;
      quantities[element.ifc_type].side_area += element.side_area;
      quantities[element.ifc_type].surface += element.surface;
    });
    return quantities;
  },

  // ------------------------deprecated ----------------
  // use getTreeChildObjects 
  getChildElements: (state, getters, rootState) => (payload) => {
    let child_elements = [];
    let parent = rootState.Ultra[payload.parent_type][payload.parent_id];
    if (parent.sites) {
      let sites = parent.sites.map(id => rootState.Ultra.sites[id]);
      child_elements = child_elements.concat(sites);
    }
    if (parent.spatialzones) {
      let spatialzones = parent.spatialzones.map(id => rootState.Ultra.spatialzones[id]);
      child_elements = child_elements.concat(spatialzones);
    }
    if (parent.buildings) {
      let buildings = parent.buildings.map(id => rootState.Ultra.buildings[id]);
      child_elements = child_elements.concat(buildings);
    }
    if (parent.buildingstoreys) {
      let buildingstoreys = parent.buildingstoreys.map(id => rootState.Ultra.buildingstoreys[id]);
      child_elements = child_elements.concat(buildingstoreys);
    }
    if (parent.spacegroups) {
      let spacegroups = parent.spacegroups.map(id => rootState.Ultra.spacegroups[id]);
      child_elements = child_elements.concat(spacegroups);
    }
    if (parent.elementassemblies) {
      let elementassemblies = parent.elementassemblies.map(id => rootState.Ultra.elementassemblies[id]);
      child_elements = child_elements.concat(elementassemblies);
    }
    let elements = [];
    if (parent.elements) {
      // elements = parent.elements.map(id => rootState.Ultra.elements[id]);
      elements = parent.elements;
    }
    // if (parent.elementassemblies) {
    //   // elements = elements.concat(parent.elementassemblies.map(id => rootState.Ultra.elementassemblies[id]))
    //   elements = parent.elementassemblies;
    // }
    if (elements.length !== 0) {
      //element wrapper
      let element_wrappers = [];
      let element_types = [];
      elements.forEach(element_id => {
        let element = {};
        if (rootState.Ultra.elements[element_id]) {
          element = rootState.Ultra.elements[element_id];
        } else if (state.project_elements[element_id]) {
          element = state.project_elements[element_id];
          element.id = parseInt(element_id);
          element.type = 'elements';
        } else {
          element.id = parseInt(element_id);
          element.type = 'elements';
          element.ifc_type = 'undefined';
          element.name = 'undefined';
        }
        if (!element_types.includes(element.ifc_type)) {
          element_wrappers.push({
            ifc_type: element.ifc_type,
            elements: [element],
            element_ids: [element.id],
            type: 'element_wrapper',
            name: element.ifc_type,
            id: 'element_wrapper#' + element.ifc_type,
            closed: true,
            parent: {
              id: parent.id,
              type: parent.type
            }
          });
          element_types.push(element.ifc_type);
        } else {
          let element_wrapper = element_wrappers.find(wrapper => wrapper.ifc_type === element.ifc_type);
          element_wrapper.elements.push(element);
          element_wrapper.element_ids.push(element.id);
        }
      });
      // child_elements = child_elements.concat(elements);
      child_elements = child_elements.concat(element_wrappers);
    }
    if (parent.plans) {
      let plans = parent.plans.map(id => rootState.Ultra.plans[id]);
      child_elements = child_elements.concat(plans);
    }
    child_elements.sort(function (a, b) {
      return a.order_index - b.order_index;
    });
    return child_elements;
  },
  // use get getAllChildObjectIds
  getAllChildElements: (state, getters, rootState) => (payload) => {
    //frontend way

    let elements = [];
    let parent = rootState.Ultra[payload.parent_type][payload.parent_id];
    if (parent.elements) {
      // elements = elements.concat(JSON.parse(JSON.stringify(parent.elements)));
      elements = elements.concat(JSON.parse(JSON.stringify(parent.elements.map(id => parseInt(id)))));
    }


    ['sites', 'spatialzones', 'buildings', 'buildingstoreys', 'spacegroups', 'elementassemblies', 'taktareas'].forEach(el => {
      if (parent[el]) {
        parent[el].forEach(id => {
          let parent2 = rootState.Ultra[el][id];
          elements = elements.concat(getters.getAllChildElements({ parent_type: parent2.type, parent_id: parent2.id, bla: 'bla' }));
        });
      }
    });
    return elements;

    //backend way
    // return rootState.Ultra[payload.parent_type][payload.parent_id].all_elements;
  },
  // use get getAllChildObjectIds
  getAllSelectedElements: (state, getters, rootState) => (payload) => {
    let elements = [];
    let trains = [];
    if (payload.train_id) {
      trains = [payload.train_id];
    } else {
      trains = rootState.Ultra.projects[payload.project_id].trains;
    }
    trains.forEach(train_id => {
      rootState.Ultra.trains[train_id].taktareas.forEach(taktarea_id => {
        elements = elements.concat(rootState.Ultra.taktareas[taktarea_id].elements);
      });
    });
    return elements;
  },
  // use get getAllChildObjectIds
  getElementTaktareas: (state, getters, rootState) => (payload) => {
    //old not sorted by trains
    // let taktareas = JSON.parse(JSON.stringify(Object.values(rootState.Ultra.taktareas).filter(taktarea => taktarea.elements.includes(id))));
    // taktareas.forEach(ta => {
    //   ta.train = Object.values(rootState.Ultra.trains).find(train => train.taktareas.includes(ta.id));
    // });
    let taktareas = [];

    rootState.Ultra.projects[payload.project_id].trains.forEach(train_id => {
      let train = JSON.parse(JSON.stringify(rootState.Ultra.trains[train_id]));
      train.taktareas.forEach(taktarea_id => {
        let taktarea = JSON.parse(JSON.stringify(rootState.Ultra.taktareas[taktarea_id]));
        if (taktarea.elements.includes(parseInt(payload.id))) {
          taktarea.train = train;
          taktareas.push(taktarea);
        }
      });
    });
    return taktareas;
  },
  // use get getAllChildObjectIds
  getContainerTaktareas: (state, getters, rootState) => (payload) => {
    let taktareas = [];
    let elements;
    if (payload.element_ids) {
      elements = payload.element_ids;
    } else {
      elements = getters.getAllChildElements(payload);
    }
    rootState.Ultra.projects[payload.project_id].trains.forEach(train_id => {
      let train = JSON.parse(JSON.stringify(rootState.Ultra.trains[train_id]));
      train.taktareas.forEach(taktarea_id => {
        let taktarea = JSON.parse(JSON.stringify(rootState.Ultra.taktareas[taktarea_id]));
        if (taktarea.elements.some(el => elements.includes(`${el}`) || elements.includes(el))) { //elementids as string in parent.all_elements
          taktarea.train = train;
          taktareas.push(taktarea);
        }
      });
    });
    return taktareas;
  },
  // use get getAllChildObjectIds
  getLinkedProcessObjectIds: (state, getters, rootState) => (payload) => {
    if (payload.tree_element.type === 'elements') {
      return payload.tree_element[payload.link_entity_name];
    } else {
      let ids = [];
      let element_ids = getters.getAllChildElements(payload.tree_element);
      for (let i = 0; i < element_ids.length; i++) {
        let id = element_ids[i];
        let el
        if (rootState.Ultra.elements[id]) {
          el = rootState.Ultra.elements[id];
        } else {
          el = state.project_elements[id];
        }
        for (let j = 0; j < el[payload.link_entity_name].length; j++) {
          let obj_id = el[payload.link_entity_name][j];
          ids[ids.length] = obj_id;
        }
      }
      return ids;
    }
  },
  // use get getAllChildObjectIds
  getLinkedSpatialObjectIds: (state, getters, rootState) => (payload) => {
    // taktarea_elements or step_elements
    if (payload.link_entity_name === 'taktarea_elements') {
      if (payload.tree_element.type === 'taktareas') {
        return payload.tree_element.elements;
      }
      else if (payload.tree_element.type === 'trains') {
        let ids = [];
        for (let i = 0; i < payload.tree_element.taktareas.length; i++) {
          let id = payload.tree_element.taktareas[i];
          let el_ids = rootState.Ultra.taktareas[id].elements;
          for (let j = 0; j < el_ids.length; j++) {
            ids[ids.length] = el_ids[j];
          }
        }
        return ids;
      }
    } else if (payload.link_entity_name === 'step_elements') {
      if (payload.tree_element.type.includes('steps')) {
        return payload.tree_element.elements;
      } else {
        let ids = [];
        getters.getProcessStepElementsRecursive(payload.tree_element, ids);
        return ids;
      }

    }
  },
  // helper function for deprecated getLinkedSpatialObjectIds
  getProcessStepElementsRecursive: (state, getters, rootState) => (payload) => {
    let hirarchy = ['projects', 'trains', 'taktareas', 'twaggons', 'tworkpackages', 'steps'];
    let hir_index = hirarchy.indexOf(payload.parent.type);
    let child_type = hirarchy[hir_index + 1];

    if (child_type === 'steps') {
      rootState.Ultra.step_types_full.forEach(step_type => {
        for (let i = 0; i < payload.parent[step_type].length; i++) {
          let step_id = payload.parent[step_type][i];
          let step = rootState.Ultra[step_type][step_id];
          for (let j = 0; j < step.elements.length; j++) {
            let el_id = step.elements[j];
            payload.element_ids[payload.element_ids.length] = el_id;
          }
        }
      })
    } else {
      for (let k = 0; k < payload.parent[child_type].length; k++) {
        let child_id = payload.parent[child_type][k];
        let child = rootState.Ultra[child_type][child_id];
        getters.getProcessStepElementsRecursive(child, payload.element_ids);
      }
    }
  },
  // use isSet1inSet2
  isVisible: (state, getters, rootState) => (payload) => {
    if (['elements', 'plans'].includes(payload.type)) {
      return rootState.Ultra[payload.type][payload.id].visible;
    } else {
      let elements = [];
      let visible = false;
      if (payload.type === 'element_wrapper') {
        payload.elements.forEach(element => {
          if (element.visible === true) {
            visible = true;
          }
        });
      } else {
        elements = getters.getAllChildElements({ parent_type: payload.type, parent_id: payload.id, bla: 'bla' });
        elements.forEach(id => {
          if (rootState.Ultra.elements[id].visible === true) {
            visible = true;
          }
        });
      }
      return visible;
    }
  },
  // no spatial units anmyore
  getSpatialUnitsLocation: (state, getters, rootState, rootGetters) => (id) => {
    let locations = rootGetters['Ultra/getUObjectsFiltered']({ type: 'locations', filter: { spatial_unit_id: id } });
    if (locations.length !== 0) {
      let plan = rootState.Ultra.plans[locations[0].plan_id];
      return {
        location: locations[0],
        plan: plan
      };
    } else {
      return false;
    }
  },
  getAllSpatialUnitsWorkpackageIds: (state, getters, rootState, rootGetters) => {
    let workpackage_ids = [];
    rootGetters['Ultra/getUObjects']({ type: 'elements' }).forEach(spatial_unit => {
      spatial_unit.workpackages.forEach(workpackage_id => {
        if (!workpackage_ids.includes(workpackage_id)) {
          workpackage_ids.push(workpackage_id);
        }
      });
    });
    return workpackage_ids;
  },
};
// Actions
const actions = {
  requestProjectElements({ commit, rootState }, project_id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/projects/${project_id}/geometry`,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
        .then(resp => {
          // console.(resp);
          commit('set_project_elements', { project_id: project_id, elements: resp.data.data.elements });
          let objects = resp.data.data.elements;
          let type = 'elements';
          commit('set_ultra_objects', { rootState, objects, type })
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  requestProjectSteps({ commit, rootState }, project_id) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/projects/${project_id}/allsteps`,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
        .then(resp => {
          // console.(resp);
          commit('set_project_steps', { project_id: project_id, steps: resp.data.data });
          Object.keys(resp.data.data).forEach(resp_type => {
            let objects = resp.data.data[resp_type];
            let type = resp_type;
            commit('set_ultra_objects', { rootState, objects, type })
          })
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },
  removeElementsFromTaktareas({ commit, getters, rootState }, payload) {
    return new Promise((resolve) => {
      let elements = [];
      if (payload.type === 'elements') {
        elements = [payload.id];
      } else if (payload.type !== 'plans') {
        elements = getters.getAllChildElements({ parent_type: payload.type, parent_id: payload.id });
      }
      elements.forEach(element_id => {
        payload.element_id = element_id;
        commit('remove_element_from_taktarea', { rootState, payload });
      });
      resolve();
    });
  },
  toggleVisibility({ commit, getters, rootState }, payload) {
    let payload_copy = JSON.parse(JSON.stringify(payload));
    if (['elements', 'plans'].includes(payload_copy.type)) {
      payload_copy.affected_elements = [rootState.Ultra[payload_copy.type][payload_copy.id]];
    } else if (payload_copy.type === 'element_wrapper') {
      payload_copy.affected_elements = payload_copy.elements;
    } else {
      payload_copy.affected_elements = JSON.parse(JSON.stringify(getters.getAllChildElements({ parent_type: payload_copy.type, parent_id: payload_copy.id })));
      payload_copy.affected_elements = payload_copy.affected_elements.map(id => rootState.Ultra.elements[id]);
    }
    if (payload_copy.affected_elements.length !== 0) {
      payload_copy.all_visible = payload_copy.affected_elements[0].visible;
    }
    commit('toggle_visibility', { rootState, payload_copy });
    // let promises = [];
    // for (var i = 0; i < payload_copy.affected_elements.length; i++) {
    //   promises.push(dispatch('toggleVisibilityHelper', {id: payload_copy.affected_elements[i].id, all_visible: payload_copy.all_visible}));
    // }
    // Promise.all(promises).then(() => {
    // });
  },
  toggleVisibilityHelper({ commit, rootState }, payload) {
    return new Promise((resolve) => {
      commit('toggle_visibility_test', { rootState, payload });
      resolve();
    });
  },
  toggleElementWrappersOpen({ commit, rootState }, payload) {
    commit('toggle_element_wappers_open', { rootState, payload });
  },
  togglePropSet({ commit, rootState }, payload) {
    commit('togglePropSet', { rootState, payload });
  },
  importIFCNew({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit('set_ifc_upload_progress', {
        loaded: 0,
        total: 0,
        percentage: 0,
      });

      const config = {
        onUploadProgress: function (progressEvent) {
          var percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          commit('set_ifc_upload_progress', {
            loaded: progressEvent.loaded,
            total: progressEvent.total,
            percentage: percentage,
          });
        }
      }

      let form_data = new FormData();
      form_data.append('ifc', payload.ifc);
      // let js_axios = axios.create({
      //   baseURL: process.env.VUE_APP_IFC_SERVER_URL,
      //   // baseURL: 'http://localhost:3000/',
      //   timeout: 0
      // });
      let strat_query = '';
      if (payload.import_strategy.value !== 'default') {
        strat_query = `?importstrategy_id=${payload.import_strategy.value}`;
      }
      axios.post(
        // url: `/importifcfile/${payload.project_id}${strat_query}`,
        `projects/${payload.project_id}/importifc${strat_query}`,
        form_data,
        config
      ).then(resp => {
        commit('dummy');
        resolve(resp);
      }).catch(err => {
        if (!err.response) {
          let error = 'Error: IFC Import Server not reachable';
          commit('set_error', error);
          commit('View/set_user_feedback', error, { root: true });
        } else {
          commit('set_error', extractErrorDetails(err));
          commit('View/set_user_feedback', err.response.data.error_msg, { root: true });
        }
        reject(err);
      });
    });
  },
  importIFC({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        ifc_data: payload.ifc_data.ifcProject,
        textures: payload.textures
      };
      axios({
        url: 'projects/' + payload.project_id + '/importifc?show=showWithEntitiesNormalized',
        method: 'POST',
        data: data,
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
        .then(resp => {
          payload.resp_data = resp.data.data;
          commit('Ultra/create_u_objects', { rootState, payload }, { root: true });
          commit('import_ifc', { rootState, payload });
          let search_array = [];
          for (let prop in resp.data.data) {
            search_array = search_array.concat(resp.data.data[prop]);
          }
          // let promises = [];
          // for (let id in payload.ifc_data.elements) {
          //   let parent = search_array.find(el => el.express_id == id);
          //   let elements = payload.ifc_data.elements[id];
          //   promises.push(
          //     dispatch('importElements', {
          //       parent_type: parent.type,
          //       parent_id: parent.id,
          //       elements: elements
          //     })
          //   );
          // }
          // Promise.all(promises).then(() => {
          dispatch('importElementsRecursive', {
            keys: JSON.parse(JSON.stringify(Object.keys(payload.ifc_data.elements))),
            elements: payload.ifc_data.elements,
            search_array: search_array
          }).then(() => {
            dispatch('Ultra/requestUObject', {
              url: [
                { projects: payload.project_id },
                { projectstructure: '' }
              ]
            },
              { root: true }
            ).then(() => {
              dispatch('Ultra/requestUObject', {
                url: [
                  { projects: payload.project_id },
                  { geometry: '' }
                ]
              },
                { root: true }
              );
            }).then(() => {
              resolve();
            });
          });
        })
        .catch(() => {
          // commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  importElementsRecursive({ commit, dispatch }, test_payload) {
    return new Promise((resolve, reject) => {
      if (test_payload.keys.length === 0) {
        resolve();
      } else {
        let id = test_payload.keys.shift();
        let parent = test_payload.search_array.find(el => el.express_id == id);
        let elements = test_payload.elements[id];
        let data = {
          elements: elements,
        };
        let js_axios = axios.create({
          baseURL: process.env.VUE_APP_IFC_SERVER_URL,
          // baseURL: 'http://localhost:3000/',
          timeout: 0
        });
        js_axios({
          url: 'importifc/' + parent.id + '/' + parent.type,
          method: 'POST',
          data: data,
        }).then(resp => {
          commit('dummy', resp);
          dispatch('importElementsRecursive', test_payload).then(() => {
            resolve();
          });
        }).catch(err => {
          reject(err);
        });
      }
    });
  },
  requestGLB({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let js_axios = axios.create({
        baseURL: process.env.VUE_APP_IFC_SERVER_URL,
        // baseURL: 'http://localhost:3000/',
        timeout: 0
      });
      js_axios({
        url: '/create-glb',
        method: 'POST',
        data: { elements: payload.elements, project_id: payload.project_id },
      }).then(resp => {
        commit('dummy', {});
        // commit('set_glb', {project_id: payload.project_id, resp: resp});
        resolve(resp.data);
      }).catch(err => {
        reject(err);
      });
    });
  },
  importElements({ commit }, payload) {
    return new Promise((resolve, reject) => {
      let data = {
        elements: payload.elements,
        // textures: payload.textures
      };
      let js_axios = axios.create({
        baseURL: 'http://localhost:3000/',
        timeout: 0
      });
      js_axios({
        url: 'importifc/' + payload.parent_id + '/' + payload.parent_type,
        method: 'POST',
        data: data,
      }).then(resp => {
        commit('dummy', resp);
        resolve();
      }).catch(err => {
        reject(err);
      });
    });
  },
  requestChildrenIds({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/projectstructure/${payload.type}/${payload.id}/elementids`,
        method: 'GET',
      })
        .then(resp => {
          commit('dummy');
          resolve(resp.data.data);
        })
        .catch(() => {
          // commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  requestElementsByTakt({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `projects/${payload.project_id}/elementsbytakt?takt=${payload.takt_index}${payload.cumulative ? '&cumulative=true' : ''}`,
        method: 'GET',
        headers: {
          'Cache-Control': 'no-cache'
        }
      })
        .then(resp => {
          commit('dummy');
          resolve(resp.data.data);
        })
        .catch(() => {
          // commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  showElementsByTakt({ dispatch }, payload) {
    dispatch('requestElementsByTakt', payload).then(resp => {
      let element_ids = resp.elements.map(id => id.toString());
      dispatch('setCollectionObjects', { action: 'set', ids_by_target: {elements: element_ids}, collection_name: 'visible_elements' });
    });
  },
  setCollectionObjects({ commit }, payload) {
    commit('set_collection_object_ids', payload);
  },
  setUiMode({ commit }, payload) {
    commit('set_ui_mode', payload);
  },
  planDetectRoomsCall({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      let form_data = new FormData();
      form_data.append('image', payload.image);
      axios({
        url: `/projects/${payload.project_id}/projectstructure/buildingstoreys/${payload.buildingstorey_id}/takeoff?scale=${payload.meter_per_pixel}&height=${payload.height}&offset_x=${payload.offset.x}&offset_y=${payload.offset.y}&offset_z=${payload.offset.z}&plan_offset_x=${payload.plan_offset_x}&plan_offset_y=${payload.plan_offset_y}`,
        method: 'POST',
        data: form_data,
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
        .then(resp => {
          let data = resp.data.data;
          commit('Ultra/create_u_objects', { rootState: rootState, payload: { resp_data: data } }, { root: true });
          let ids = [];
          for (let i = 0; i < data.elements.length; i++) {
            ids.push(data.elements[i].id)
          }
          commit('add_unstaged_element_ids', { rootState, ids, payload });
          resolve(ids);
        })
        .catch(() => {
          // commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  uploadPlan({ commit, rootState }, payload) {
    return new Promise((resolve, reject) => {
      let form_data = new FormData();
      form_data.append('plan', payload.plan);
      axios({
        url: `/projects/${payload.project_id}/projectstructure/plans?parent_type=${payload.parent_type}&parent_id=${payload.parent_id}&show=showWithEntitiesNormalized`,
        method: 'POST',
        data: form_data,
        headers: {
          'Cache-Control': 'no-cache'
        },
      })
        .then(resp => {
          let data = resp.data.data;
          commit('Ultra/create_u_objects', { rootState: rootState, payload: { resp_data: data } }, { root: true });
          commit('add_plans', { rootState, data, payload });
          resolve(data.plans[0].id);
        })
        .catch(() => {
          // commit('set_error', extractErrorDetails(err));
          reject();
        });
    });
  },
  removePlanFromParent({ commit, rootState }, plan) {
    commit('remove_plan_from_parent', { rootState, plan });
  },
  initializeTreeSettings({ commit }) {
    commit('initialize_tree_settings');
  },
  updateSetting({ commit }, payload) {
    commit('update_setting', payload);
  },
  initializeProcessParents({ commit, rootState }, project_id) {
    commit('initialize_process_parents', { rootState, project_id })
  },
  setVisibleElements({ commit }, payload) {
    commit('set_visible_elements', payload);
  },
  updateProjectElements({ commit }, payload) {
    commit('update_project_elements', payload);
  },
  linkObjects({commit, rootState }, payload) {
    return new Promise((resolve) => {
      let data = {
        action: payload.action,
        elements: payload.elements,
      }
      if(payload.link_target === 'taktareas') {
        data.taktareas = payload.taktareas;
      }
      else if (payload.link_target === 'steps') {
        data.tworksteps = payload.tworksteps;
      }
      axios({
        url: `/projects/${payload.project_id}/projectstructure/elements/0/linkentities`,
        method: 'PUT',
        data: data,
      // }).then(() => {
      }).then(resp => {
        // commit('link_objects', {rootState, payload});
        // commit('Ultra/create_u_objects', { rootState: rootState, payload: {resp_data: resp.data.data.entities_normalized} }, { root: true });
        commit('link_objects', {rootState, resp});
        commit('unlink_from_backend', {rootState: rootState, del_pairs_for_frontend: resp.data.data.del_pairs_for_frontend});
        resolve();
      });
    });
  },
  updateProjectStructureValue({ commit }, payload) {
    commit('update_value', payload);
  },
  toggleFilter({commit}, payload) {
    commit('toggle_filter', payload);
  },
  requestProjectElementsFiltered({commit}, payload){
    return new Promise((resolve, reject) => {
      axios({
        url: `/projects/${payload.project_id}/projectstructure/elements/0/filter`,
        method: 'POST',
        data: {filter: payload.filter},
      })
        .then(resp => {
          commit('set_spatial_filter_elements', resp.data.data.elements);
          resolve(resp.data.data.elements);
        })
        .catch(() => {
          reject();
        });
    })
  },
  requestProjectStepsFiltered({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios({
        url: `/projects/${payload.project_id}/filtersteps`,
        method: 'POST',
        data: {filter: payload.filter},
      })
        .then(resp => {
          commit('set_process_filter_elements', resp.data.data);
          resolve();
        })
        .catch(() => {
          reject();
        });
    })
  },
  parseBlobGeometry({commit, rootState}, payload) {
    commit('parse_blob_geometry', {rootState, payload});
  },
  resetStructure({commit}) {
    commit('reset_structure');
  }
};

// Mutations
const mutations = {
  remove_element_from_taktarea(state, { rootState, payload }) {
    let taktareas = Object.values(rootState.Ultra.taktareas).filter(taktarea => taktarea.elements.includes(payload.element_id));
    taktareas.forEach(taktarea => {
      let index = taktarea.elements.indexOf(payload.element_id);
      taktarea.elements.splice(index, 1);
    });
  },
  toggle_visibility(state, { rootState, payload_copy }) {
    let elements = JSON.parse(JSON.stringify(rootState.Ultra.elements));
    // let elements = rootState.Ultra.elements;
    let inverted_visible = !payload_copy.all_visible;
    // console.time();
    payload_copy.affected_elements.forEach(element => {
      elements[element.id].visible = inverted_visible;
    });
    rootState.Ultra.elements = elements;
    // console.timeEnd();
  },
  toggle_visibility_test(state, { rootState, payload }) {
    rootState.Ultra.elements[payload.id].visible = !payload.all_visible;
  },
  toggle_element_wappers_open(state, { rootState, payload }) {
    let parent = JSON.parse(JSON.stringify(rootState.Ultra[payload.parent.type][payload.parent.id]));
    //let parent = rootState.Ultra[payload.parent.type][payload.parent.id];
    let index = parent.element_wrappers_open.indexOf(payload.id);
    if (index === -1) {
      parent.element_wrappers_open.push(payload.id);
    } else {
      parent.element_wrappers_open.splice(index, 1);
    }
    rootState.Ultra[payload.parent.type][payload.parent.id] = parent;
  },
  togglePropSet(state, { rootState, payload }) {
    let prop_set = rootState.Ultra[payload.type][payload.id].ifc_prop_sets[payload.index];
    prop_set.closed = !prop_set.closed;
  },
  import_ifc(state, { rootState, payload }) {
    payload.resp_data.sites.forEach(site => {
      rootState.Ultra.projects[payload.project_id].sites.push(site.id);
    });
  },
  set_glb(state, payload) {
    state.glbs[payload.project_id] = payload.resp.data;
  },
  set_project_elements(state, payload) {
    state.project_elements = payload.elements;
  },
  set_ultra_objects(state, { rootState, objects, type }) {
    // übergangsweise handling 
    // const keys = Object.keys(objects);
    // for (let i = 0; i < keys.length; i++) {
    //   const id = keys[i];
    //   if (rootState.Ultra[type][id]) {
    //     Object.assign(rootState.Ultra[type][id], objects[id]);
    //   } else {
    //     if (rootState.Ultra.definitions[type]) {
    //       const definition = JSON.parse(JSON.stringify(rootState.Ultra.definitions[type]));
    //       Vue.set(rootState.Ultra[type], id, Object.assign(definition, objects[id]));
    //     } else {
    //       rootState.Ultra[type][id] = objects[id];
    //     }
    //   }
    // }
    // end
    rootState.Ultra[type] = objects;
    // Vue.set(rootState.Ultra, type, objects)
  },
  set_project_steps(state, payload) {
    state.project_steps = payload.steps;
  },
  update_project_elements(state, payload) {
    // update project_elements object with the new data, keeping the current information by given id
    Vue.set(state.project_elements, payload.id, Object.assign({}, state.project_elements[payload.id], payload.data));
  },
  update_value(state, payload){
    state[payload.key] = payload.value;
  },
  dummy() {

  },
  set_ui_mode(state, payload) {
    state.ui_mode = payload;
  },
  set_collection_object_ids(state, payload) {
    Object.keys(payload.ids_by_target).forEach(target_name => {
      let collection = state[payload.collection_name][target_name];
      let ids = payload.ids_by_target[target_name];
      if (payload.action === 'set') {
        state[payload.collection_name][target_name] = ids;
        // Vue.set(state[payload.collection_name], target_name, ids);
      } else {
        let collection_copy;
        if (payload.action === 'remove') {
          collection_copy = [];
          let payload_set = new Set(ids);
          for (let i = 0; i < collection.length; i++) {
            let id = parseInt(collection[i]);
            if (!payload_set.has(id)) {
              collection_copy[collection_copy.length] = `${id}`;
            }
          }
          payload_set = null;
        } else if (payload.action === 'add') {
          collection_copy = JSON.parse(JSON.stringify(collection));
          let collection_set = new Set(collection);
          for (let i = 0; i < ids.length; i++) {
            let id = `${ids[i]}`;
            if (!collection_set.has(id)) {
              collection_copy[collection_copy.length] = id;
            }
            // let index = collection.indexOf(id);
            // if (index === -1) {
            //   collection_copy[collection_copy.length] = id;
            // }
          }
          collection_set = null;
        }
        state[payload.collection_name][target_name] = collection_copy;
        // Vue.set(state[payload.collection_name], target_name, collection_copy);
      }
    })
  },
  set_ifc_upload_progress(state, payload) {
    state.ifc_upload_loaded = payload.loaded;
    state.ifc_upload_total = payload.total;
    state.ifc_upload_percentage = payload.percentage;
  },
  add_unstaged_element_ids(state, { rootState, ids, payload }) {
    rootState.Ultra.projects[payload.project_id].unstaged_elements = rootState.Ultra.projects[payload.project_id].unstaged_elements.concat(ids);
  },
  add_plans(state, { rootState, data, payload }) {
    rootState.Ultra[payload.parent_type][payload.parent_id].plans.push(data.plans[0].id);
  },
  remove_plan_from_parent(state, { rootState, plan }) {
    let parent = rootState.Ultra[plan.parent.type][plan.parent.id];
    let index = parent.plans.indexOf(plan.id);
    parent.plans.splice(index, 1);
  },
  initialize_tree_settings(state) {
    // set tree settings objects
    let tree_names = [
      'spatial_tree',
      'element_steps',
      'element_taktareas',
      'spatial_collection',
      'process_tree',
      'step_elements',
      'taktarea_elements',
      'process_collection'
    ];
    ['wrapper', 'sorting', 'grouping'].forEach(setting_name => {
      tree_names.forEach(tree_name => {
        Vue.set(state[`tree_settings_${setting_name}`], tree_name, {});
      });
    });
    // spatial
    let options = {
      spatial_trees: [
        'spatial_tree',
        'step_elements',
        'taktarea_elements',
        'spatial_collection'
      ],
      spatial_wrappers: [
        'sites',
        'spatialzones',
        'buildings',
        'buildingstoreys',
        'spacegroups',
        'elementassemblies',
        'object_wrapper',
        'show_empty_wrapper',
      ],
      // process
      process_trees: [
        'process_tree',
        'element_steps',
        'element_taktareas',
        'process_collection',
      ],
      process_wrappers: [
        'trains',
        'taktareas',
        'twaggons',
        'tworkpackages',
        'object_wrapper',
        'show_empty_wrapper',
      ],
    };

    ['spatial', 'process'].forEach(tree_type => {
      let trees = options[`${tree_type}_trees`];
      trees.forEach(tree_name => { // trees
        // wrappers
        let wrapper_settings = options[`${tree_type}_wrappers`];
        wrapper_settings.forEach(setting_name => { // wrapper settings
          let local_variable = localStorage.getItem(`tree_settings_wrapper_${tree_name}_${setting_name}`);
          if (local_variable !== null) {
            let local_bool;
            if (local_variable === 'false' || local_variable === false) {
              local_bool = false;
            } else {
              local_bool = true;
            }
            Vue.set(state.tree_settings_wrapper[tree_name], setting_name, local_bool);
          } else {
            let value;
            if (state.default_tree_settings_wrapper[tree_name] && state.default_tree_settings_wrapper[tree_name][setting_name]) {
              value = state.default_tree_settings_wrapper[tree_name][setting_name];
            } else {
              value = true;
            }
            Vue.set(state.tree_settings_wrapper[tree_name], setting_name, value);
          }
        });
        // sorting
        Vue.set(state.tree_settings_sorting[tree_name], 'sort_by', 'order_index');
        Vue.set(state.tree_settings_sorting[tree_name], 'sort_direction', 'up');
        // grouping
        Vue.set(state.tree_settings_grouping[tree_name], 'group_by', tree_type === 'spatial' ? 'ifc_type' : 'type');
      });
    });
  },
  update_setting(state, payload) {
    state[`tree_settings_${payload.type}`][payload.tree][payload.setting] = payload.value;
    localStorage.setItem(`tree_settings_${payload.type}_${payload.tree}_${payload.setting}`, payload.value);
  },
  initialize_process_parents(state, { rootState, project_id }) {
    let project = rootState.Ultra.projects[project_id];
    project.trains.forEach(train_id => {
      let train = rootState.Ultra.trains[train_id];
      Vue.set(train, 'parent', { type: 'projects', id: project_id });
      train.taktareas.forEach(ta_id => {
        let taktarea = rootState.Ultra.taktareas[ta_id];
        Vue.set(taktarea, 'parent', { type: 'trains', id: train_id });
        taktarea.twaggons.forEach(waggon_id => {
          let twaggon = rootState.Ultra.twaggons[waggon_id];
          Vue.set(twaggon, 'parent', { type: 'taktareas', id: ta_id });
          twaggon.tworkpackages.forEach(wp_id => {
            let tworkpackage = rootState.Ultra.tworkpackages[wp_id];
            Vue.set(tworkpackage, 'parent', { type: 'twaggons', id: waggon_id });
            tworkpackage.tworksteps.forEach(tworkstep_id => {
              let tworkstep = rootState.Ultra.tworksteps[tworkstep_id];
              Vue.set(tworkstep, 'parent', { type: 'tworkpackages', id: wp_id });
            })
          })
        })
      })
    });
  },
  link_objects(state, {rootState, resp}) {
    let entities_normalized = resp.data.data.entities_normalized;
    Object.keys(entities_normalized).forEach(type => {
      for (let i = 0; i < entities_normalized[type].length; i++) {
        let object = entities_normalized[type][i];
        Object.keys(object).forEach(key => {
          if (key !== 'id') {
            Vue.set(rootState.Ultra[type][object.id], key, object[key]); // check reactivity!!!
          }
        })
      }
    })
  },
  unlink_from_backend(state, {rootState, del_pairs_for_frontend}) {
    for (let index = 0; index < del_pairs_for_frontend.length; index++) {
      const pair = del_pairs_for_frontend[index];
      // STEP -> remove elements
      let el_index_of_step = rootState.Ultra[pair.type][pair.other_id].elements.indexOf(parseInt(pair.element_id));
      if (el_index_of_step === -1) {
        el_index_of_step = rootState.Ultra[pair.type][pair.other_id].elements.indexOf(pair.element_id);
      }
      if (el_index_of_step === -1) {
        el_index_of_step = rootState.Ultra[pair.type][pair.other_id].elements.indexOf(`${pair.element_id}`);
      }
      if (el_index_of_step !== -1) {
        // remove element from step
        rootState.Ultra[pair.type][pair.other_id].elements.splice(el_index_of_step, 1);
      }

      // ELEMENT -> remove step
      let step_index_of_el = rootState.Ultra.elements[pair.element_id][pair.type].indexOf(parseInt(pair.other_id));
      if (step_index_of_el === -1) {
        step_index_of_el = rootState.Ultra.elements[pair.element_id][pair.type].indexOf(pair.other_id);
      }
      if (step_index_of_el === -1) {
        step_index_of_el = rootState.Ultra.elements[pair.element_id][pair.type].indexOf(`${pair.other_id}`);
      }
      if (step_index_of_el !== -1) {
        // remove step from element
        rootState.Ultra.elements[pair.element_id][pair.type].splice(step_index_of_el, 1);
      }
    }
  },
  link_objects_old(state, {rootState, payload}) {
    //elements
    for (let i = 0; i < payload.elements.length; i++) {
      let el_id = payload.elements[i];
      let element = rootState.Ultra.elements[el_id];
      //taktareas
      for (let j = 0; j < payload.taktareas.length; j++) {
        let ta_id = payload.taktareas[j];
        let ta_index = element.taktareas.indexOf(ta_id);
        //add
        if (payload.action === 'add' && ta_index === -1) {
          //ta
          // element.taktareas[element.taktareas.length] = ta_id; //ta in el
          element.taktareas.push(ta_id); //ta in el
          let taktarea = rootState.Ultra.taktareas[ta_id];
          // taktarea.elements[taktarea.elements.length] = el_id; //el in ta
          taktarea.elements.push(el_id); //el in ta
        }
        //remove
        else if (payload.action === 'remove' && ta_index !== -1) {
          //ta
          element.taktareas.splice(ta_index, 1); //ta in el
          let taktarea = rootState.Ultra.taktareas[ta_id];
          let ta_el_index = taktarea.elements.indexOf(el_id);
          taktarea.elements.splice(ta_el_index, 1); //el in ta
        }
      }

      //steps
      if (payload.link_target === 'steps') {
        for (let k = 0; k < payload.tworksteps.length; k++) {
          let step_id = payload.tworksteps[k];
          let step_index = element.tworksteps.indexOf(step_id);
          // add
          if (payload.action === 'add' && step_index === -1) {
            //ta
            // element.tworksteps[element.tworksteps.length] = step_id; //step in el
            element.tworksteps.push(step_id); //step in el
            let tworkstep = rootState.Ultra.tworksteps[step_id];
            // tworkstep.elements[tworkstep.elements.length] = el_id; //el in step
            tworkstep.elements.push(el_id); //el in step
          }
          //remove
          else if (payload.action === 'remove' && step_index !== -1) {
            element.tworksteps.splice(step_index, 1); // step in el;
            let tworkstep = rootState.Ultra.tworksteps[step_id];
            let step_el_index = tworkstep.elements.indexOf(step_id);
            tworkstep.splice(step_el_index, 1); // el in step
          }
        }
      }
      
    }
  },
  toggle_filter(state, payload) {
    state.filter[payload.type].active = payload.value;
  },
  set_spatial_filter_elements(state, payload) {
    Vue.set(state.filter.spatial.objects, 'elements', payload);
  },
  set_process_filter_elements(state, payload) {
    Vue.set(state.filter.process.objects, 'tworksteps', payload.tworksteps);
  },
  parse_blob_geometry(state, {rootState, payload}) {
    
    let obj = rootState.Ultra[payload.type][payload.id];
    let parsed_geom = JSON.parse(obj.geometry);
    Vue.set(obj, 'geometry', parsed_geom);
  },
  reset_structure(state){
    state.filter = {
      spatial: {
        active: false,
        objects: {
          elements: []
        }
      },
      process: {
        active: false,
        objects: {
          tworksteps: []
        }
      }
    };
    state.selected_elements = {
      elements: [],
    };
    state.selected_steps = {
      tworksteps: []
    };
  }

};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
